/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.5 0A9.5 9.5 0 1 1 0 9.5 9.5 9.5 0 0 1 9.5 0Zm0 1A8.5 8.5 0 1 0 18 9.5 8.5 8.5 0 0 0 9.5 1Zm-5 10.18.07.13a5.44 5.44 0 0 0 9.94 0l.07-.13.88.47-.07.13a6.44 6.44 0 0 1-11.71 0l-.07-.14Zm1.86-5.4a1 1 0 1 1-1 1 1 1 0 0 1 .96-1Zm6.38 0a1 1 0 1 1-1 1 1 1 0 0 1 .96-1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'SmileyFaceIcon';

export default Icon;
